module.exports = __webpack_public_path__ + "static/media/trumpetQuestion.648e1e07.png";